const Categories = [
    {category: "General Knowledge",
    img:"https://www.hubspot.com/hubfs/marketer%20building%20a%20survey%20through%20the%20best%20online%20quiz%20makers.jpg",
    value: 9},
    { category: "Books",
    img:"https://jerryjenkins.com/wp-content/uploads/2015/06/Library-Picture-Crop-1024x512.jpg",
     value: 10 },
    { category: "Films", 
    img:"https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/best-movies-1614634680.jpg?crop=1.00xw:1.00xh;0,0&resize=480:*",
    value: 11 },
    { category: "Music",
    img:"https://www.verdict.co.uk/wp-content/uploads/2019/09/disrupt-music-industry.jpg",
     value: 12 },
    { category: "Musicals and Theaters",
    img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8PW5vd8INKjjDzU8PGVycREtbGEn-WUHQaUVp3un349ijXA1-XM9gfSjWFacpTeydajA&usqp=CAU",
    value: 13 },
    { category: "Television",
    img:"https://observer.com/wp-content/uploads/sites/2/2020/05/long-running-comedy-shows.jpg?quality=80",
     value: 14 },
    { category: "Video Games",
    img:"https://i.pinimg.com/originals/1d/a8/7a/1da87aab8ef6ca07598a8671fc752f6d.jpg",
     value: 15 },
    { category: "Board Games",
    img:"https://www.scienceofpeople.com/wp-content/uploads/2020/05/best-board-games-for-adults.jpg",
     value: 16 },
    { category: "Science and Nature",
    img:"https://allea.org/wp-content/uploads/2019/06/shutterstock_520698799small.jpg",
     value: 17 },
    { category: "Computer",
    img:"https://media.proprofs.com/images/QM/user_images/2503852/New%20Project%20(36)(306).jpg",
     value: 18 },
    { category: "Mathematics",
    img:"https://img.jagranjosh.com/imported/images/E/Articles/Math-640x315_September_2018.jpg",
     value: 19 },
    { category: "Mythology",
    img:"https://media.swncdn.com/via/13937-istockgetty-images-pluspaseven-2.jpg",
    value: 20 },
    { category: "Sports",
    img:"https://ijclp.com/wp-content/uploads/2021/10/Sports.jpg",
    value: 21 },
    { category: "Geography",
    img:"https://www.worldatlas.com/r/w1200/upload/29/6d/1c/shutterstock-1140854771.jpg",
     value: 22 },
    { category: "History",
    img:"https://womengovtcollegevisakha.ac.in/images/history.jpg",
     value: 23 },
    { category: "Politics",
    img:"https://i0.wp.com/www.hrreview.co.uk/wp-content/uploads/politics.jpg?resize=1280%2C640&ssl=1",
     value: 24 },
    { category: "Art",
    img:"https://i0.wp.com/post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/09/art-therapy-1296x728-header-1024x575.jpg?w=1155&h=1528",
     value: 25 },
    { category: "Celebrities",
    img:"https://i2-prod.cambridge-news.co.uk/incoming/article18257770.ece/ALTERNATES/s1200d/0_US_Oscars_045076.jpg",
     value: 26 },
    { category: "Animals",
    img:"https://cdn.hswstatic.com/gif/petstorepuppies-1.jpg",
     value: 27 },
    { category: "Vehicles",
    img:"https://www.electrive.com/wp-content/uploads/2022/05/xpeng-p7-2022-01-min.png",
     value: 28 },
    { category: "Comics",
    img:"https://images.indianexpress.com/2022/02/comics-2.jpg",
     value: 29 },
    { category: "Gadgets",
    img:"https://cdn.techjuice.pk/wp-content/uploads/2017/07/image-13-1280x720.png",
     value: 30 },
    { category: "Japanese Anime",
    img:"https://wallpaperaccess.com/full/538948.png",
     value: 31 },
    { category: "Cartoon and Animations",
    img:"https://media.baamboozle.com/uploads/images/30962/1585142334_144856",
     value: 32 },
  ];

  export default Categories;